import { defaultBrandSettings, getBrandFromLocalStorage, isClient } from '@systemeio/util';
import { useEffect, useState } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useFirstAvailableRoute } from 'shared/hooks/use-first-available-route';
import { useMetadataFromServer } from 'shared/hooks/use-metadata-from-server';
import { useRouter } from 'shared/hooks/use-router';
import useUser from 'shared/hooks/use-user';
import { useChristmas } from 'shared/layout/components/snow/use-christmas';
import { isSIO } from 'shared/utils/is-sio';
const SioButton = () => {
  const {
    user,
    isDisabled
  } = useUser();
  const {
    firstAvailableRoute
  } = useFirstAvailableRoute();
  const router = useRouter();
  const {
    data: metaDataFromServer
  } = useMetadataFromServer();
  const christmasFeatureIsOn = useChristmas();
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  const logoLoader = <div className="bg-text-secondary h-[35px] min-h-[35px] w-[35px] min-w-[35px] animate-pulse rounded-full"></div>;
  const getLogoImage = (src: string = christmasFeatureIsOn ? 'https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-christmas.png' : defaultBrandSettings.logo?.path, alt: string = defaultBrandSettings.name) => {
    return <img className="h-[35px] min-h-[35px] w-[35px] min-w-[35px] object-cover" src={src} alt={alt} />;
  };
  const getWlLogo = () => {
    if (isClient() && hydrated) {
      const brand = getBrandFromLocalStorage();
      if (brand) {
        return getLogoImage(brand.logo?.path, brand.name);
      }
    }
  };
  const getSioLogo = () => {
    if (isSIO(metaDataFromServer?.hostOnServer)) {
      return getLogoImage();
    }
  };
  const getLogo = () => {
    return getSioLogo() ?? getWlLogo() ?? logoLoader;
  };
  return user && !isDisabled ? <button className={'ring-background-secondary rounded-full ring-offset-0 focus-visible:ring-2'} onClick={() => router.push(firstAvailableRoute)}>
      <LinkWithoutPrefetch className={'tab focus:outline-hidden'} tabIndex={-1} href={firstAvailableRoute}>
        {getLogo()}
      </LinkWithoutPrefetch>
    </button> : getLogo();
};
export default SioButton;